import React from 'react';
import styles from './SessionInfoEntry.module.scss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

export function SessionInfoEntry({ sessionDetails }) {
    const { t } = useTranslation('account');
    const localizedDate = function (epochSecond) {
        return new Intl.DateTimeFormat(i18next.language, {
            timeZone: 'UTC',
            dateStyle: 'medium',
            timeStyle: 'long'
        }).format(new Date(epochSecond * 1000));
    };

    return sessionDetails.map(sessionDetail => (
        <div className={styles.tableWrapper} key={sessionDetail.id}>
            <div className={styles.rowWrapper}>
                <div className={styles.row}>
                    <div className={classNames(styles.highlight, styles.dataRow)}>
                        <div className={classNames(styles.labelCell, styles.cell)}>
                            {t('SessionInfoEntry.ipAddress')}
                        </div>
                        <div className={styles.cell}>{sessionDetail.ipAddress}</div>
                    </div>
                    <div className={styles.dataRow}>
                        <div className={classNames(styles.labelCell, styles.cell)}>
                            {t('SessionInfoEntry.accessType')}
                        </div>
                        <div className={styles.cell}>{sessionDetail.accessType}</div>
                    </div>
                    <div className={styles.dataRow}>
                        <div className={classNames(styles.labelCell, styles.cell)}>
                            {t('SessionInfoEntry.creationTime')}
                        </div>
                        <div className={styles.cell}>{localizedDate(sessionDetail.creationTime)}</div>
                    </div>
                    <div className={styles.dataRow}>
                        <div className={classNames(styles.labelCell, styles.cell)}>
                            {t('SessionInfoEntry.lastAccessTime')}
                        </div>
                        <div className={styles.cell}>{localizedDate(sessionDetail.lastAccessedTime)}</div>
                    </div>
                </div>
            </div>
        </div>
    ));
}
